module.exports = {
  ES: {
    en: "Spain",
    es: "España",
    ca: "España",
  },
  AF: {
    en: "Afghanistan",
    es: "Afganistán",
    ca: "Afganistán",
  },
  AX: {
    en: "Åland",
    es: "Åland",
    ca: "Åland",
  },
  AL: {
    en: "Albania",
    es: "Albania",
    ca: "Albania",
  },
  DE: {
    en: "Germany",
    es: "Alemania",
    ca: "Alemania",
  },
  AD: {
    en: "Andorra",
    es: "Andorra",
    ca: "Andorra",
  },
  AO: {
    en: "Angola",
    es: "Angola",
    ca: "Angola",
  },
  AI: {
    en: "Anguilla",
    es: "Anguila",
    ca: "Anguila",
  },
  AQ: {
    en: "Antarctica",
    es: "Antártida",
    ca: "Antártida",
  },
  AG: {
    en: "Antigua and Barbuda",
    es: "Antigua y Barbuda",
    ca: "Antigua y Barbuda",
  },
  AN: {
    en: "Netherlands Antilles",
    es: "Antillas Neerlandesas",
    ca: "Antillas Neerlandesas",
  },
  SA: {
    en: "Saudi Arabia",
    es: "Arabia Saudita",
    ca: "Arabia Saudita",
  },
  DZ: {
    en: "Algeria",
    es: "Argelia",
    ca: "Argelia",
  },
  AR: {
    en: "Argentina",
    es: "Argentina",
    ca: "Argentina",
  },
  AM: {
    en: "Armenia",
    es: "Armenia",
    ca: "Armenia",
  },
  AW: {
    en: "Aruba",
    es: "Aruba",
    ca: "Aruba",
  },
  AU: {
    en: "Australia",
    es: "Australia",
    ca: "Australia",
  },
  AT: {
    en: "Austria",
    es: "Austria",
    ca: "Austria",
  },
  AZ: {
    en: "Azerbaijan",
    es: "Azerbaiyán",
    ca: "Azerbaiyán",
  },
  BS: {
    en: "Bahamas",
    es: "Bahamas",
    ca: "Bahamas",
  },
  BH: {
    en: "Bahrain",
    es: "Baréin",
    ca: "Baréin",
  },
  BD: {
    en: "Bangladesh",
    es: "Bangladés",
    ca: "Bangladés",
  },
  BB: {
    en: "Barbados",
    es: "Barbados",
    ca: "Barbados",
  },
  BY: {
    en: "Belarus",
    es: "Bielorrusia",
    ca: "Bielorrusia",
  },
  BE: {
    en: "Belgium",
    es: "Bélgica",
    ca: "Bélgica",
  },
  BZ: {
    en: "Belize",
    es: "Belice",
    ca: "Belice",
  },
  BJ: {
    en: "Benin",
    es: "Benín",
    ca: "Benín",
  },
  BM: {
    en: "Bermuda",
    es: "Bermudas",
    ca: "Bermudas",
  },
  BT: {
    en: "Bhutan",
    es: "Bután",
    ca: "Bután",
  },
  BO: {
    en: "Bolivia",
    es: "Bolivia",
    ca: "Bolivia",
  },
  BA: {
    en: "Bosnia and Herzegovina",
    es: "Bosnia y Herzegovina",
    ca: "Bosnia y Herzegovina",
  },
  BW: {
    en: "Botswana",
    es: "Botsuana",
    ca: "Botsuana",
  },
  BV: {
    en: "Bouvet Island",
    es: "Isla Bouvet",
    ca: "Isla Bouvet",
  },
  BR: {
    en: "Brazil",
    es: "Brasil",
    ca: "Brasil",
  },
  BN: {
    en: "Brunei Darussalam",
    es: "Brunéi",
    ca: "Brunéi",
  },
  BG: {
    en: "Bulgaria",
    es: "Bulgaria",
    ca: "Bulgaria",
  },
  BF: {
    en: "Burkina Faso",
    es: "Burkina Faso",
    ca: "Burkina Faso",
  },
  BI: {
    en: "Burundi",
    es: "Burundi",
    ca: "Burundi",
  },
  CV: {
    en: "Cape Verde",
    es: "Cabo Verde",
    ca: "Cabo Verde",
  },
  KY: {
    en: "Cayman Islands",
    es: "Islas Caimán",
    ca: "Islas Caimán",
  },
  KH: {
    en: "Cambodia",
    es: "Camboya",
    ca: "Camboya",
  },
  CM: {
    en: "Cameroon",
    es: "Camerún",
    ca: "Camerún",
  },
  CA: {
    en: "Canada",
    es: "Canadá",
    ca: "Canadá",
  },
  CF: {
    en: "Central African Republic",
    es: "República Centroafricana",
    ca: "República Centroafricana",
  },
  TD: {
    en: "Chad",
    es: "Chad",
    ca: "Chad",
  },
  CZ: {
    en: "Czech Republic",
    es: "República Checa",
    ca: "República Checa",
  },
  CL: {
    en: "Chile",
    es: "Chile",
    ca: "Chile",
  },
  CN: {
    en: "China",
    es: "China",
    ca: "China",
  },
  CY: {
    en: "Cyprus",
    es: "Chipre",
    ca: "Chipre",
  },
  CC: {
    en: "Cocos (Keeling) Islands",
    es: "Islas Cocos",
    ca: "Islas Cocos",
  },
  CO: {
    en: "Colombia",
    es: "Colombia",
    ca: "Colombia",
  },
  KM: {
    en: "Comoros",
    es: "Comoras",
    ca: "Comoras",
  },
  CG: {
    en: "Congo, Republic of",
    es: "República del Congo",
    ca: "República del Congo",
  },
  CD: {
    en: "Democratic Republic of the Congo",
    es: "Rep. Dem. del Congo",
    ca: "Rep. Dem. del Congo",
  },
  CK: {
    en: "Cook Islands",
    es: "Islas Cook",
    ca: "Islas Cook",
  },
  KP: {
    en: "North Korea",
    es: "Corea del Norte",
    ca: "Corea del Norte",
  },
  KR: {
    en: "South Korea",
    es: "Corea del Sur",
    ca: "Corea del Sur",
  },
  CI: {
    en: "Côte D'ivoire",
    es: "Costa de Marfil",
    ca: "Costa de Marfil",
  },
  CR: {
    en: "Costa Rica",
    es: "Costa Rica",
    ca: "Costa Rica",
  },
  HR: {
    en: "Croatia",
    es: "Croacia",
    ca: "Croacia",
  },
  CU: {
    en: "Cuba",
    es: "Cuba",
    ca: "Cuba",
  },
  DK: {
    en: "Denmark",
    es: "Dinamarca",
    ca: "Dinamarca",
  },
  DM: {
    en: "Dominica",
    es: "Dominica",
    ca: "Dominica",
  },
  DO: {
    en: "Dominican Republic",
    es: "República Dominicana",
    ca: "República Dominicana",
  },
  EC: {
    en: "Ecuador",
    es: "Ecuador",
    ca: "Ecuador",
  },
  EG: {
    en: "Egypt",
    es: "Egipto",
    ca: "Egipto",
  },
  SV: {
    en: "El Salvador",
    es: "El Salvador",
    ca: "El Salvador",
  },
  AE: {
    en: "United Arab Emirates",
    es: "Emiratos Árabes Unidos",
    ca: "Emiratos Árabes Unidos",
  },
  ER: {
    en: "Eritrea",
    es: "Eritrea",
    ca: "Eritrea",
  },
  SK: {
    en: "Slovakia",
    es: "Eslovaquia",
    ca: "Eslovaquia",
  },
  SI: {
    en: "Slovenia",
    es: "Eslovenia",
    ca: "Eslovenia",
  },
  US: {
    en: "United States of America",
    es: "Estados Unidos",
    ca: "Estados Unidos",
  },
  UM: {
    en: "United States Minor Outlying Islands",
    es: "Islas ultramarinas de Estados Unidos",
    ca: "Islas ultramarinas de Estados Unidos",
  },
  EE: {
    en: "Estonia",
    es: "Estonia",
    ca: "Estonia",
  },
  ET: {
    en: "Ethiopia",
    es: "Etiopía",
    ca: "Etiopía",
  },
  FO: {
    en: "Faroe Islands",
    es: "Islas Feroe",
    ca: "Islas Feroe",
  },
  PH: {
    en: "Philippines",
    es: "Filipinas",
    ca: "Filipinas",
  },
  FI: {
    en: "Finland",
    es: "Finlandia",
    ca: "Finlandia",
  },
  FJ: {
    en: "Republic of Fiji",
    es: "Fiyi",
    ca: "Fiyi",
  },
  FR: {
    en: "France",
    es: "Francia",
    ca: "Francia",
  },
  GA: {
    en: "Gabon",
    es: "Gabón",
    ca: "Gabón",
  },
  GM: {
    en: "Gambia",
    es: "Gambia",
    ca: "Gambia",
  },
  GE: {
    en: "Georgia",
    es: "Georgia",
    ca: "Georgia",
  },
  GS: {
    en: "British Overseas Territory of the South Georgia and the South Sandwich Islands",
    es: "Islas Georgias del Sur y Sandwich del Sur",
    ca: "Islas Georgias del Sur y Sandwich del Sur",
  },
  GH: {
    en: "Ghana",
    es: "Ghana",
    ca: "Ghana",
  },
  GI: {
    en: "Gibraltar",
    es: "Gibraltar",
    ca: "Gibraltar",
  },
  GD: {
    en: "Grenada",
    es: "Granada",
    ca: "Granada",
  },
  GR: {
    en: "Greece",
    es: "Grecia",
    ca: "Grecia",
  },
  GL: {
    en: "Greenland",
    es: "Groenlandia",
    ca: "Groenlandia",
  },
  GP: {
    en: "Guadeloupe",
    es: "Guadalupe",
    ca: "Guadalupe",
  },
  GU: {
    en: "Guam",
    es: "Guam",
    ca: "Guam",
  },
  GT: {
    en: "Guatemala",
    es: "Guatemala",
    ca: "Guatemala",
  },
  GF: {
    en: "French Guiana",
    es: "Guayana Francesa",
    ca: "Guayana Francesa",
  },
  GG: {
    en: "Guernsey",
    es: "Guernsey",
    ca: "Guernsey",
  },
  GN: {
    en: "Guinea",
    es: "Guinea",
    ca: "Guinea",
  },
  GQ: {
    en: "Equatorial Guinea",
    es: "Guinea Ecuatorial",
    ca: "Guinea Ecuatorial",
  },
  GW: {
    en: "Guinea-Bissau",
    es: "Guinea-Bissau",
    ca: "Guinea-Bissau",
  },
  GY: {
    en: "Guyana",
    es: "Guyana",
    ca: "Guyana",
  },
  HT: {
    en: "Haiti",
    es: "Haití",
    ca: "Haití",
  },
  HM: {
    en: "Heard Island and McDonald Islands",
    es: "Islas Heard y McDonald",
    ca: "Islas Heard y McDonald",
  },
  HN: {
    en: "Honduras",
    es: "Honduras",
    ca: "Honduras",
  },
  HK: {
    en: "Hong Kong",
    es: "Hong Kong",
    ca: "Hong Kong",
  },
  HU: {
    en: "Hungary",
    es: "Hungría",
    ca: "Hungría",
  },
  IN: {
    en: "India",
    es: "India",
    ca: "India",
  },
  ID: {
    en: "Indonesia",
    es: "Indonesia",
    ca: "Indonesia",
  },
  IR: {
    en: "Iran",
    es: "Irán",
    ca: "Irán",
  },
  IQ: {
    en: "Iraq",
    es: "Irak",
    ca: "Irak",
  },
  IE: {
    en: "Ireland",
    es: "Irlanda",
    ca: "Irlanda",
  },
  IS: {
    en: "Iceland",
    es: "Islandia",
    ca: "Islandia",
  },
  IL: {
    en: "Israel",
    es: "Israel",
    ca: "Israel",
  },
  IT: {
    en: "Italy",
    es: "Italia",
    ca: "Italia",
  },
  JM: {
    en: "Jamaica",
    es: "Jamaica",
    ca: "Jamaica",
  },
  JP: {
    en: "Japan",
    es: "Japón",
    ca: "Japón",
  },
  JE: {
    en: "Jersey",
    es: "Jersey",
    ca: "Jersey",
  },
  JO: {
    en: "Jordan",
    es: "Jordania",
    ca: "Jordania",
  },
  KZ: {
    en: "Kazakhstan",
    es: "Kazajistán",
    ca: "Kazajistán",
  },
  KE: {
    en: "Kenya",
    es: "Kenia",
    ca: "Kenia",
  },
  KG: {
    en: "Kyrgyzstan",
    es: "Kirguistán",
    ca: "Kirguistán",
  },
  KI: {
    en: "Kiribati",
    es: "Kiribati",
    ca: "Kiribati",
  },
  KW: {
    en: "Kuwait",
    es: "Kuwait",
    ca: "Kuwait",
  },
  LA: {
    en: "Laos",
    es: "Laos",
    ca: "Laos",
  },
  LS: {
    en: "Lesotho",
    es: "Lesoto",
    ca: "Lesoto",
  },
  LV: {
    en: "Latvia",
    es: "Letonia",
    ca: "Letonia",
  },
  LB: {
    en: "Lebanon",
    es: "Líbano",
    ca: "Líbano",
  },
  LR: {
    en: "Liberia",
    es: "Liberia",
    ca: "Liberia",
  },
  LY: {
    en: "Libya",
    es: "Libia",
    ca: "Libia",
  },
  LI: {
    en: "Liechtenstein",
    es: "Liechtenstein",
    ca: "Liechtenstein",
  },
  LT: {
    en: "Lithuania",
    es: "Lituania",
    ca: "Lituania",
  },
  LU: {
    en: "Luxembourg",
    es: "Luxemburgo",
    ca: "Luxemburgo",
  },
  MO: {
    en: "Macau",
    es: "Macao",
    ca: "Macao",
  },
  MK: {
    en: "North Macedonia",
    es: "ARY Macedonia",
    ca: "ARY Macedonia",
  },
  MG: {
    en: "Madagascar",
    es: "Madagascar",
    ca: "Madagascar",
  },
  MY: {
    en: "Malaysia",
    es: "Malasia",
    ca: "Malasia",
  },
  MW: {
    en: "Malawi",
    es: "Malawi",
    ca: "Malawi",
  },
  MV: {
    en: "Maldives",
    es: "Maldivas",
    ca: "Maldivas",
  },
  ML: {
    en: "Mali",
    es: "Malí",
    ca: "Malí",
  },
  MT: {
    en: "Malta",
    es: "Malta",
    ca: "Malta",
  },
  FK: {
    en: "Falkland Islands",
    es: "Islas Malvinas",
    ca: "Islas Malvinas",
  },
  IM: {
    en: "Isle of Main",
    es: "Isla de Man",
    ca: "Isla de Man",
  },
  MP: {
    en: "Northern Mariana Islands",
    es: "Islas Marianas del Norte",
    ca: "Islas Marianas del Norte",
  },
  MA: {
    en: "Morocco",
    es: "Marruecos",
    ca: "Marruecos",
  },
  MH: {
    en: "Marshall Islands",
    es: "Islas Marshall",
    ca: "Islas Marshall",
  },
  MQ: {
    en: "Martinique",
    es: "Martinica",
    ca: "Martinica",
  },
  MU: {
    en: "Mauritius",
    es: "Mauricio",
    ca: "Mauricio",
  },
  MR: {
    en: "Mauritania",
    es: "Mauritania",
    ca: "Mauritania",
  },
  YT: {
    en: "Mayotte",
    es: "Mayotte",
    ca: "Mayotte",
  },
  MX: {
    en: "Mexico",
    es: "México",
    ca: "México",
  },
  FM: {
    en: "Micronesia",
    es: "Micronesia",
    ca: "Micronesia",
  },
  MD: {
    en: "Moldova",
    es: "Moldavia",
    ca: "Moldavia",
  },
  MC: {
    en: "Monaco",
    es: "Mónaco",
    ca: "Mónaco",
  },
  MN: {
    en: "Mongolia",
    es: "Mongolia",
    ca: "Mongolia",
  },
  ME: {
    en: "Montenegro",
    es: "Montenegro",
    ca: "Montenegro",
  },
  MS: {
    en: "Montserrat",
    es: "Montserrat",
    ca: "Montserrat",
  },
  MZ: {
    en: "Mozambique",
    es: "Mozambique",
    ca: "Mozambique",
  },
  MM: {
    en: "Myanmar",
    es: "Myanmar",
    ca: "Myanmar",
  },
  NA: {
    en: "Namibia",
    es: "Namibia",
    ca: "Namibia",
  },
  NR: {
    en: "Nauru",
    es: "Nauru",
    ca: "Nauru",
  },
  CX: {
    en: "Christmas Island",
    es: "Isla de Navidad",
    ca: "Isla de Navidad",
  },
  NP: {
    en: "Nepal",
    es: "Nepal",
    ca: "Nepal",
  },
  NI: {
    en: "Nicaragua",
    es: "Nicaragua",
    ca: "Nicaragua",
  },
  NE: {
    en: "Niger",
    es: "Níger",
    ca: "Níger",
  },
  NG: {
    en: "Nigeria",
    es: "Nigeria",
    ca: "Nigeria",
  },
  NU: {
    en: "Niue",
    es: "Niue",
    ca: "Niue",
  },
  NF: {
    en: "Norfolk",
    es: "Norfolk",
    ca: "Norfolk",
  },
  NO: {
    en: "Norway",
    es: "Noruega",
    ca: "Noruega",
  },
  NC: {
    en: "New Caledonia",
    es: "Nueva Caledonia",
    ca: "Nueva Caledonia",
  },
  NZ: {
    en: "New Zealand",
    es: "Nueva Zelanda",
    ca: "Nueva Zelanda",
  },
  OM: {
    en: "Oman",
    es: "Omán",
    ca: "Omán",
  },
  NL: {
    en: "Netherlands",
    es: "Países Bajos",
    ca: "Países Bajos",
  },
  PK: {
    en: "Pakistan",
    es: "Pakistán",
    ca: "Pakistán",
  },
  PW: {
    en: "Palau",
    es: "Palaos",
    ca: "Palaos",
  },
  PS: {
    en: "State of Palestine",
    es: "Autoridad Nacional Palestina",
    ca: "Autoridad Nacional Palestina",
  },
  PA: {
    en: "Panama",
    es: "Panamá",
    ca: "Panamá",
  },
  PG: {
    en: "Papua New Guinea",
    es: "Papúa Nueva Guinea",
    ca: "Papúa Nueva Guinea",
  },
  PY: {
    en: "Paraguay",
    es: "Paraguay",
    ca: "Paraguay",
  },
  PE: {
    en: "Peru",
    es: "Perú",
    ca: "Perú",
  },
  PN: {
    en: "Pitcairn Islands",
    es: "Islas Pitcairn",
    ca: "Islas Pitcairn",
  },
  PF: {
    en: "French Polynesia",
    es: "Polinesia Francesa",
    ca: "Polinesia Francesa",
  },
  PL: {
    en: "Poland",
    es: "Polonia",
    ca: "Polonia",
  },
  PT: {
    en: "Portugal",
    es: "Portugal",
    ca: "Portugal",
  },
  PR: {
    en: "Puerto Rico",
    es: "Puerto Rico",
    ca: "Puerto Rico",
  },
  QA: {
    en: "Qatar",
    es: "Catar",
    ca: "Catar",
  },
  GB: {
    en: "United Kingdom",
    es: "Reino Unido",
    ca: "Reino Unido",
  },
  RE: {
    en: "Réunion",
    es: "Reunión",
    ca: "Reunión",
  },
  RW: {
    en: "Rwanda",
    es: "Ruanda",
    ca: "Ruanda",
  },
  RO: {
    en: "Romania",
    es: "Rumania",
    ca: "Rumania",
  },
  RU: {
    en: "Russia",
    es: "Rusia",
    ca: "Rusia",
  },
  EH: {
    en: "Western Sahara",
    es: "República Árabe Saharaui Democrática",
    ca: "República Árabe Saharaui Democrática",
  },
  SB: {
    en: "Solomon Islands",
    es: "Islas Salomón",
    ca: "Islas Salomón",
  },
  WS: {
    en: "Samoa",
    es: "Samoa",
    ca: "Samoa",
  },
  AS: {
    en: "American Samoa",
    es: "Samoa Estadounidense",
    ca: "Samoa Estadounidense",
  },
  KN: {
    en: "San Cristóbal y Nieves",
    es: "San Cristóbal y Nieves",
    ca: "San Cristóbal y Nieves",
  },
  SM: {
    en: "San Marino",
    es: "San Marino",
    ca: "San Marino",
  },
  PM: {
    en: "Saint Pierre and Miquelon",
    es: "San Pedro y Miquelón",
    ca: "San Pedro y Miquelón",
  },
  VC: {
    en: "San Vicente y las Granadinas",
    es: "San Vicente y las Granadinas",
    ca: "San Vicente y las Granadinas",
  },
  SH: {
    en: "Saint Helena",
    es: "Santa Helena",
    ca: "Santa Helena",
  },
  LC: {
    en: "Saint Lucia",
    es: "Santa Lucía",
    ca: "Santa Lucía",
  },
  ST: {
    en: "São Tomé and Príncipe",
    es: "Santo Tomé y Príncipe",
    ca: "Santo Tomé y Príncipe",
  },
  SN: {
    en: "Senegal",
    es: "Senegal",
    ca: "Senegal",
  },
  RS: {
    en: "Serbia",
    es: "Serbia",
    ca: "Serbia",
  },
  SC: {
    en: "Seychelles",
    es: "Seychelles",
    ca: "Seychelles",
  },
  SL: {
    en: "Sierra Leone",
    es: "Sierra Leona",
    ca: "Sierra Leona",
  },
  SG: {
    en: "Singapore",
    es: "Singapur",
    ca: "Singapur",
  },
  SY: {
    en: "Syria",
    es: "Siria",
    ca: "Siria",
  },
  SO: {
    en: "Somalia",
    es: "Somalia",
    ca: "Somalia",
  },
  LK: {
    en: "Sri Lanka",
    es: "Sri Lanka",
    ca: "Sri Lanka",
  },
  SZ: {
    en: "Swaziland",
    es: "Suazilandia",
    ca: "Suazilandia",
  },
  ZA: {
    en: "South Africa",
    es: "Sudáfrica",
    ca: "Sudáfrica",
  },
  SD: {
    en: "Sudan",
    es: "Sudán",
    ca: "Sudán",
  },
  SE: {
    en: "Sweden",
    es: "Suecia",
    ca: "Suecia",
  },
  CH: {
    en: "Switzerland",
    es: "Suiza",
    ca: "Suiza",
  },
  SR: {
    en: "Suriname",
    es: "Surinam",
    ca: "Surinam",
  },
  SJ: {
    en: "Svalbard and Jan Mayen",
    es: "Svalbard y Jan Mayen",
    ca: "Svalbard y Jan Mayen",
  },
  TH: {
    en: "Thailand",
    es: "Tailandia",
    ca: "Tailandia",
  },
  TW: {
    en: "Taiwan",
    es: "Taiwán",
    ca: "Taiwán",
  },
  TZ: {
    en: "Tanzania",
    es: "Tanzania",
    ca: "Tanzania",
  },
  TJ: {
    en: "Tajikistan",
    es: "Tayikistán",
    ca: "Tayikistán",
  },
  IO: {
    en: "British Indian Ocean Territory",
    es: "Territorio Británico del Océano Índico",
    ca: "Territorio Británico del Océano Índico",
  },
  TF: {
    en: "French Austral Lands",
    es: "Territorios Australes Franceses",
    ca: "Territorios Australes Franceses",
  },
  TL: {
    en: "East Timor",
    es: "Timor Oriental",
    ca: "Timor Oriental",
  },
  TG: {
    en: "Togo",
    es: "Togo",
    ca: "Togo",
  },
  TK: {
    en: "Tokelau",
    es: "Tokelau",
    ca: "Tokelau",
  },
  TO: {
    en: "Tonga",
    es: "Tonga",
    ca: "Tonga",
  },
  TT: {
    en: "Trinidad and Tobago",
    es: "Trinidad y Tobago",
    ca: "Trinidad y Tobago",
  },
  TN: {
    en: "Tunisia",
    es: "Túnez",
    ca: "Túnez",
  },
  TC: {
    en: "Turks and Caicos Islands",
    es: "Islas Turcas y Caicos",
    ca: "Islas Turcas y Caicos",
  },
  TM: {
    en: "Turkmenistan",
    es: "Turkmenistán",
    ca: "Turkmenistán",
  },
  TR: {
    en: "Turkey",
    es: "Turquía",
    ca: "Turquía",
  },
  TV: {
    en: "Tuvalu",
    es: "Tuvalu",
    ca: "Tuvalu",
  },
  UA: {
    en: "Ukraine",
    es: "Ucrania",
    ca: "Ucrania",
  },
  UG: {
    en: "Uganda",
    es: "Uganda",
    ca: "Uganda",
  },
  UY: {
    en: "Uruguay",
    es: "Uruguay",
    ca: "Uruguay",
  },
  UZ: {
    en: "Uzbekistán",
    es: "Uzbekistán",
    ca: "Uzbekistán",
  },
  VU: {
    en: "Vanuatu",
    es: "Vanuatu",
    ca: "Vanuatu",
  },
  VA: {
    en: "Vatican City",
    es: "Ciudad del Vaticano",
    ca: "Ciudad del Vaticano",
  },
  VE: {
    en: "Venezuela",
    es: "Venezuela",
    ca: "Venezuela",
  },
  VN: {
    en: "Vietnam",
    es: "Vietnam",
    ca: "Vietnam",
  },
  VG: {
    en: "British Virgin Islands",
    es: "Islas Vírgenes Británicas",
    ca: "Islas Vírgenes Británicas",
  },
  VI: {
    en: "U.S. Virgin Islands",
    es: "Islas Vírgenes de los Estados Unidos",
    ca: "Islas Vírgenes de los Estados Unidos",
  },
  WF: {
    en: "Wallis and Futuna",
    es: "Wallis y Futuna",
    ca: "Wallis y Futuna",
  },
  YE: {
    en: "Yemen",
    es: "Yemen",
    ca: "Yemen",
  },
  DJ: {
    en: "Djibouti",
    es: "Yibuti",
    ca: "Yibuti",
  },
  ZM: {
    en: "Zambia",
    es: "Zambia",
    ca: "Zambia",
  },
  ZW: {
    en: "Zimbabwe",
    es: "Zimbabue",
    ca: "Zimbabue",
  },
};
